// Formatter is hoisted to module scope — Intl.NumberFormat construction is
// ~10x slower than calling .format() on a cached instance, and this helper
// fires per-field per-node during canvas paint.
const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

/**
 * Formats a USD value with thousand separators and `$` prefix.
 * Integer-only by design: TVL/liquidity/market-cap fields don't need cents.
 * If a future field needs cents, add a sibling helper — don't make this one branch.
 */
export function formatCurrencyUsd(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const n = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(n)) return String(value);
  return usdFormatter.format(n);
}
